import { render, staticRenderFns } from "./RowBlockSkeleton.vue?vue&type=template&id=41195dd9&scoped=true&"
import script from "./RowBlockSkeleton.vue?vue&type=script&lang=js&"
export * from "./RowBlockSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./RowBlockSkeleton.vue?vue&type=style&index=0&id=41195dd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41195dd9",
  null
  
)

export default component.exports